import React from 'react';

export type WorkspaceFindBarProps = {
  searchDraft: string;
  onSearchDraftChange: (value: string) => void;
  onSubmit: () => void;
  onClear: () => void;
  onPrev: () => void;
  onNext: () => void;
  showNavSuffix: boolean;
  activeIndex: number;
  totalMatches: number;
  inputAriaLabel?: string;
  disabled?: boolean;
};

const WorkspaceFindBar: React.FC<WorkspaceFindBarProps> = ({
  searchDraft,
  onSearchDraftChange,
  onSubmit,
  onClear,
  onPrev,
  onNext,
  showNavSuffix,
  activeIndex,
  totalMatches,
  inputAriaLabel = '찾기',
  disabled = false,
}) => {
  const hasSearchDraftText = searchDraft.length > 0;

  return (
    <div className="cp-budget-note-search-bar" role="search">
      <div
        className={
          'cp-budget-note-search-input-shell' +
          (hasSearchDraftText ? ' has-clear' : '') +
          (showNavSuffix ? ' has-nav' : '')
        }
      >
        <input
          type="text"
          className="cp-budget-note-search-input"
          value={searchDraft}
          disabled={disabled}
          onChange={(e) => onSearchDraftChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onSubmit();
            }
          }}
          placeholder="찾기"
          aria-label={inputAriaLabel}
        />
        {hasSearchDraftText || showNavSuffix ? (
          <div className="cp-budget-note-search-input-suffix" aria-live="polite">
            {showNavSuffix ? (
              <>
                <span className="cp-budget-note-search-count">
                  {totalMatches ? `${activeIndex + 1}/${totalMatches}` : '0/0'}
                </span>
                <button
                  type="button"
                  className="cp-budget-note-search-nav-btn"
                  onClick={onPrev}
                  disabled={disabled || !totalMatches}
                  aria-label="이전 찾기 결과"
                  title="이전"
                >
                  <svg viewBox="0 0 20 14" width="16" height="12" focusable="false" aria-hidden>
                    <path d="M6 2 2.5 5.5l1.2 1.2L5 5.4V12h2V5.4l1.3 1.3 1.2-1.2L6 2z" fill="currentColor" />
                  </svg>
                </button>
                <button
                  type="button"
                  className="cp-budget-note-search-nav-btn"
                  onClick={onNext}
                  disabled={disabled || !totalMatches}
                  aria-label="다음 찾기 결과"
                  title="다음"
                >
                  <svg viewBox="0 0 20 14" width="16" height="12" focusable="false" aria-hidden>
                    <path d="M6 12l3.5-3.5-1.2-1.2L7 8.6V2H5v6.6L3.7 7.3 2.5 8.5 6 12z" fill="currentColor" />
                  </svg>
                </button>
              </>
            ) : null}
            {hasSearchDraftText ? (
              <button
                type="button"
                className="cp-budget-note-search-clear-btn"
                onClick={onClear}
                disabled={disabled}
                aria-label="찾기 지우기"
                title="찾기 지우기"
              >
                ×
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
      <button
        type="button"
        className="cp-budget-note-search-submit"
        onClick={onSubmit}
        disabled={disabled}
        aria-label="찾기"
        title="찾기"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" focusable="false" aria-hidden>
          <path
            fill="currentColor"
            d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          />
        </svg>
      </button>
    </div>
  );
};

export default WorkspaceFindBar;
